import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class InternalAdminToolService {
    async getClientByEvoOrganisationId(organisationId: string, corporateSite: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/InternalAdminTool/organisationId/${organisationId}/getaccclient?corpSiteName=${corporateSite}`;
        let response = await getAuthenticatedFetch()(url);

        return await response.json();
    }

    async checkUninitialisedACCOrganisationExists(organisationId: string, corporateSite: string): Promise<boolean> {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/InternalAdminTool/organisationId/${organisationId}/uninitialisedclientexists?corpSiteName=${corporateSite}`;
        let response = await getAuthenticatedFetch()(url);
        
        const result = await response.text();
        return result.toLowerCase() === 'true';
    }

    async getClientByClientIdForInternalAdminTool(clientId: number, corporateSite: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/InternalAdminTool/clientId/${clientId}?corpSiteName=${corporateSite}`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }

    async hookClient(clientId: string, organisationId: string, corporateSite: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/InternalAdminTool/hookClient`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                clientId: clientId,
                organisationId: organisationId,
                corpSiteName: corporateSite
            })
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to hook client');
        }

        return response.ok;
    }

    async unlinkClientFromEvo(clientId: number, corporateSite: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/InternalAdminTool/unlinkClientFromEvo`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                clientId: clientId,
                corpSiteName: corporateSite
            })
        });
        
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to unlink client');
        }

        return response.ok;
    }
}

export default new InternalAdminToolService();
